import { createFileRoute } from "@tanstack/react-router";
import { seoHead } from "@/lib/seo/head";
import AdminMembers from "@/pages/AdminMembers";
import AdminGate from "@/components/AdminGate";

export const Route = createFileRoute("/admin/members")({
  head: () => seoHead("/admin/members"),
  component: () => (
    <AdminGate><AdminMembers /></AdminGate>
  ),
});
